module.exports = __webpack_public_path__ + "img/mobile_platform.4f90c651.svg";